<template>
  <div>
    <base-header class="pb-6 bg-light">
      <b-row aling-v="center" class="py-4">
        <b-col cols="12" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">Activity</h6>
        </b-col>
        <b-col cols="12" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>

    </base-header>

    <b-container fluid class="mt--6">
      <b-card no-body>
        <span class="h1 text-dark mt-4 ml-3 text-center"> Today's Activity</span>


        <b-form class="m-5">
          <b-row class="mb-4">
            <b-col cols="6" xl="2" lg="3" md="4" sm="6">
              <b-form-select
                label-for="per-page-select"
                v-model="activityForm.searchRange"
                :options="periodOption"
                value-field="key"
                text-field="label"
                size="sm"
              ></b-form-select>
            </b-col>
            <b-col >
              <div class="">
                <base-button type="primary" title="Search" size="sm" v-on:click="activityLog" :loading="submitLoading">
                    <i v-if="!submitLoading" class="fas fa-search">  </i>  Search
                </base-button>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" xl="8" lg="7" md="7" sm="6">
              <b-form-group
                label=""
                label-for="per-page-select"
                label-cols-sm="0"
                label-cols-md="0"
                label-cols-lg="0"
                label-align-sm="center"
                label-size="sm"
                class="mb-2 per-page-select"
              >
              <label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
              <b-form-select
                id="per-page-select"
                class="diameter-report-select"
                v-model="perPage"
                :options="pageOptions"
                size="sm"
                v-on:input="changePageOption(perPage)"
              ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="12" xl="4" lg="5" md="5" sm="6" class="customer-table-select">
              <b-form-group
                label=""
                label-for="filter-input"
                label-align-sm="right"
                label-size="sm "
                class="mb-0 per-page-select"
              >
                <label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
                <b-input-group size="sm">
                  <b-form-input id="filter-input2" v-model="filter" class="mb-4"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <div class="text-center w-100">
            <b-icon icon="three-dots"
                    class="text-center" animation="cylon"
                    font-scale="4"
                    v-if="loadingStatus"></b-icon>
          </div>
          <b-table
            v-if="!loadingStatus"
            striped hover
            :items="tableData"
            :fields="tableColumns"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            head-variant="light"
            table-class="text-nowrap"
            class="data-management-table primary-table"
            sticky-header="true"
            thead-class="white"
            show-empty
            responsive
            small
            @filtered="onFiltered"
          >
            <template #cell(response)="row">
              <!--              <div v-highlight>-->
              <!--              <pre>-->
              <!--                <code class="json">{{ row.item.response }}</code>-->
              <!--              </pre>-->
              <!--              </div>-->
              <base-button type="primary" title="Show Details" size="sm" v-on:click="showModal(row.item.response)" >
                  Show Details
              </base-button>
              
            </template>

          </b-table>

          <!-- Info modal -->
          <b-modal title="Details" ok-only centered id="details_modal">
            <span class="responsive-table">
            <div v-highlight class="overflow-auto w-auto h-auto">
                  <pre><code class="json">{{
                      fJson(modalContent)
                    }}</code></pre>
            </div>
              </span>
          </b-modal>

          <b-row class="mt-4">
            <b-col >
              <p class="ml-3 nowrap">{{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
            </b-col>
            <b-col >
              <b-pagination
                class="flex-fill-custom pr-4 ml-3 justify-content-end"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                size="sm"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </b-container>
  </div>
</template>


<script>
import AuthService from "@/common/api-services/auth-service";
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import pagination from '../../../common/format/pagination'
import coreutils from "@/common/coreutils";

export default {
  name: "Activity",
  components: {
    RouteBreadCrumb,
  },
  data() {
    return {
      loadingStatus: false,
      totalRows: 0,
      currentPage: 1,
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      tableColumns: [
        {key: 'actiondate', label: 'Date', sortable: true, sortDirection: 'desc'},
        {key: 'method', label: 'Action', sortable: true, sortDirection: 'desc'},
        {key: 'user', label: 'User', sortable: true, sortDirection: 'desc'},
        {key: 'fault', label: 'Error', sortable: true, sortDirection: 'desc'},
        {
          key: 'response', label: 'Message', sortable: true, sortDirection: 'desc',
          // formatter: (value, key, item) => {
          //   let res = value;
          //   try {
          //     res = JSON.parse(res);
          //     res = commonService.parseJsonToHtml(res);
          //   } catch (e) {
          //     console.error(e,res)
          //   }
          //   return res
          // },
        },
      ],
      modalContent: '',
      tableData: [],
      localData: [],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      activityForm: {
        searchRange: '15_min'
      },
      submitLoading: false,
      periodOption: [
        {key: '15_min', label: 'Last 15 mins'},
        {key: '1_hr', label: 'Last 1 hour'},
        {key: '1_day', label: 'Last 1 day'},
        {key: '1_wk', label: 'Last 1 week'},
        {key: '1_month', label: 'Last 1 month'},
      ],
    }
  },
  mounted() {
    document.title = 'Activity';
    this.activityLog();
    this.getTotalRows();
  },
  methods: {

    fJson(text) {
      return coreutils.formatJson(text);
    },

    showModal(content) {
      this.modalContent = content;
      this.$bvModal.show('details_modal');
    },

    //https://bootstrap-vue.org/docs/components/table
    activityLog() {
      this.loadingStatus = true;
      this.submitLoading = true
      this.tableData = [];
      AuthService.getTransactionHistory(this.activityForm.searchRange).then(res => {
        this.loadingStatus = false;
        this.submitLoading = false;
        if (res !== 'No data found' && typeof res !== "string") {
          //process the results value and json decode then stringify and then add PRE or code tags.
          let data = res.map(d => {
            try {
              d.response = JSON.parse(d.response);
              //d.response = commonService.parseJsonToHtml(d.response);
              //d.response = JSON.stringify(d.response);
              //d.response = '<code>' + d.response + '</code>';
            } catch (e) {
              console.error(e, d.response)
            }
            return d
          });
          this.tableData = data;
          this.totalRows = data.length;
        }
        this.getTotalRows()
      })
    },

    changePageOption(page) {
			this.getTotalRows();
		},

    getTotalRows() {
			if (this.perPage > this.totalRows) {
				this.fromPage = this.totalRows;
			} else {
				this.fromPage = this.perPage;
			}
		},
		startPage() {
		   return pagination.startPageFunc(this.currentPage, this.perPage)
		}, 
		lastPage() {
			return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows)
		},
    onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
    },
  }
}
</script>
